
import type { BlogAuthorStoryblok, BlogCategoryStoryblok, Story } from '@/types'

export const useBlogStore = defineStore('blog', () => {
  const mainStore = useMainStore()
  const articleWordCount = ref(0)

  const date = computed(() => {
    return mainStore.storyData.first_published_at !== null
      ? new Date(mainStore.storyData.first_published_at as string)
      : null
  })
  const rawDate = ref('')
  const title = computed(() => mainStore.storyData.content?.meta?.title || '')

  const authorsData = computed<Story<BlogAuthorStoryblok>[]>(() => {
    return mainStore.storyData?.content?.authors || []
  })
  const categoriesData = computed<Story<BlogCategoryStoryblok>[]>(() => {
    return mainStore.storyData?.content?.categories || []
  })

  return {
    date,
    authorsData,
    title,
    categoriesData,
    articleWordCount,
    rawDate,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBlogStore, import.meta.hot))
}
